<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormCataestatus" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div v-if="objCataestatus.isDefault==0" class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objCataestatus.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
					</div>					
					<br>

                    <div class="form-group row">
                        <h6>Duracion estimada de fase</h6>
						<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="Nombre">Días</label>
                            <select class="form-control-search form-select" v-model="objCataestatus.DiasDuracion" >
                                <option v-for="(item,index) in dias" :key="index"  :value="item">{{ item }}</option>
                            </select>
	
							<CValidation v-if="this.errorvalidacion.DiasDuracion" :Mensaje="'*'+errorvalidacion.DiasDuracion[0]"/>
						</div>

                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="Nombre">Horas</label>
							<select class="form-control-search form-select" v-model="objCataestatus.HorasDuracion">
                                <option v-for="(item,index) in horas" :key="index"  :value="item">{{ item }}</option>
                            </select>

							<CValidation v-if="this.errorvalidacion.HorasDuracion" :Mensaje="'*'+errorvalidacion.HorasDuracion[0]"/>
						</div>

                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
							<label class="form-label" for="Nombre">Minutos</label>
                            <select class="form-control-search form-select" v-model="objCataestatus.MinutosDuracion">
                                <option v-for="(item,index) in minutos" :key="index"  :value="item">{{ item }}</option>
                            </select>

							<CValidation v-if="this.errorvalidacion.MinutosDuracion" :Mensaje="'*'+errorvalidacion.MinutosDuracion[0]"/>
						</div>

					</div>

                    <br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormCataestatus',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCataestatus: {
				// IdCataEstatus: 0,
                IdEstatusProceso: 0,
				Nombre: '',
                isDefault:0,
                DiasDuracion:0,
                HorasDuracion:0,
                MinutosDuracion:0
				
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,

            dias:[],
            horas:[],
            minutos:[],

			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objCataestatus.IdEstatusProceso == 0) {
				await this.$http.post(
					'catasestatus',this.objCataestatus
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'catasestatus/'+this.objCataestatus.IdEstatusProceso,
					this.objCataestatus
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "catasestatus/"+this.objCataestatus.IdEstatusProceso
            ).then((res) => {
                this.objCataestatus = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objCataestatus.Fecha.replace(/-/g,'\/');
                this.objCataestatus.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCataestatus = {
				// IdCataEstatus: 0,
                IdEstatusProceso: 0,
				Nombre: '',
                isDefault:0,
				DiasDuracion:0,
                HorasDuracion:0,
                MinutosDuracion:0
            }
            this.errorvalidacion = [];
        },

        rangosCombos() {
            
            for (let i = 0; i < 8; i++) { 
                this.dias.push(i);
            }

            for (let i = 0; i < 24; i++) { 
                this.horas.push(i);
            }

            let valor2 = 0; 
            for (let i = 0; i < 12; i++) { 
                this.minutos.push(valor2);
                valor2 += 5; 
            }
        }
    },
    created() {
		this.poBtnSave.Toast = 0;
        this.rangosCombos();

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                // this.objCataestatus.IdCataEstatus = Id;
                this.objCataestatus.IdEstatusProceso = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
